var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPhysicalActivityNew = function SvgIconPhysicalActivityNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.5 6.53 9.2a2 2 0 0 0 .494 3.011l2.182 1.31a1 1 0 0 1 .38 1.3L7 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 6 1.6-2.4a1 1 0 0 1 1.1-.41l4.8 1.31 4 3 2.1 3.775a1 1 0 0 0 1.19.463L20 11m-5.5-3.5-3.206 3.735M4 15l-4 5"
  })))));
};
export { SvgIconPhysicalActivityNew as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSIxNiIgY3k9IjIiIHI9IjIiLz4KICAgICAgICAgICAgPHBhdGggZD0iTTEwLjUgNC41IDYuNTMgOS4yYTIgMiAwIDAgMCAuNDk0IDMuMDExbDIuMTgyIDEuMzFhMSAxIDAgMCAxIC4zOCAxLjNMNyAyMCIvPgogICAgICAgICAgICA8cGF0aCBkPSJtMyA2IDEuNi0yLjRhMSAxIDAgMCAxIDEuMS0uNDFsNC44IDEuMzEgNCAzIDIuMSAzLjc3NWExIDEgMCAwIDAgMS4xOS40NjNMMjAgMTFNMTQuNSA3LjVsLTMuMjA2IDMuNzM1TTQgMTVsLTQgNSIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";